import {Route, Routes, Navigate} from 'react-router-dom';
import DashboardPage from '../pages/admin/DashboardPage';
import DatabasePage from '../pages/admin/DatabasePage';
import DatabaseSyncPage from '../pages/admin/DatabaseSyncPage';
import DocsPage from '../pages/admin/DocsPage';
import EquipmentPage from '../pages/admin/EquipmentPage';
import FeedbackPage from '../pages/admin/FeedbackPage';
import VocaPage from '../pages/admin/VocaPage';

export default function AdminRoutes() {
    return (
        <Routes>
            <Route path='/' element={<Navigate to='/admin/feedback' replace />} />
            {/* <Route path='dashboard' element={<DashboardPage />}/> */}
            {/* <Route path='database' element={<DatabasePage />} /> */}
            <Route path='database-sync' element={<DatabaseSyncPage />} />
            <Route path='docs' element={<DocsPage />}/>
            <Route path='docs/:id' element={<DocsPage />} />
            <Route path='equipment-mapping' element={<EquipmentPage />} />
            <Route path='feedback' element={<FeedbackPage />}/>
            {/* <Route path='voca' element={<VocaPage />} /> */}
        </Routes>
    );
}
